import Marquee from "react-fast-marquee";
import { Snowflake } from "lucide-react";

const ITEMS = ["3S Instant Cooling", "9m/s Airflow", "100 Speed Levels", "12H Battery", "Cold Compress + Fan", "Type-C Fast Charge"];

export default function EditorialMarquee() {
    return (
        <div data-testid="editorial-marquee" className="marquee-fade border-y border-white/10 py-5 bg-white/[0.02]">
            <Marquee speed={28} gradient={false} pauseOnHover>
                {ITEMS.map((item) => (
                    <span key={item} className="flex items-center gap-6 mx-6">
                        <span className="font-display uppercase tracking-[0.2em] text-lg md:text-xl text-zinc-400">{item}</span>
                        <Snowflake className="w-4 h-4 text-cyan-300/70" />
                    </span>
                ))}
            </Marquee>
        </div>
    );
}
